import { ContainerRadioButton } from './styles';
import { Radio, RadioGroupProps, Space } from 'antd';

interface option {
  label: string;
  value: string | number | boolean;
}

interface RadioButton extends RadioGroupProps {
  options: option[];
  direction?: 'vertical' | 'horizontal';
}

export const ARadioButton: React.FC<RadioButton> = ({
  options,
  direction,
  ...res
}) => {
  const renderOptions = (children: React.ReactNode) => {
    if (direction === 'vertical') {
      return <Space direction={direction}>{children}</Space>;
    }
    return children;
  };

  return (
    <ContainerRadioButton>
      <Radio.Group {...res}>
        {renderOptions(
          <>
            {options.map((op, index) => (
              <Radio key={`radio-button-${index}`} value={op.value}>
                {op.label}
              </Radio>
            ))}
          </>,
        )}
      </Radio.Group>
    </ContainerRadioButton>
  );
};
